import { render, staticRenderFns } from "./indexConfig.vue?vue&type=template&id=24dfc0a4&"
import script from "./indexConfig.vue?vue&type=script&lang=js&"
export * from "./indexConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports